import { Download } from "lucide-react";

/**
 * Downloads a CSV by opening the URL in a new tab — cookies (Admin auth)
 * are automatically sent by the browser (same-origin, `withCredentials`
 * axios instance already established the httpOnly cookies on the domain).
 * A plain <a href download> is preferred over a fetch+blob dance because
 * (a) the file streams direct from server to disk, and (b) any 401/403
 * is surfaced by the browser without us re-implementing auth handling.
 */
export default function ExportCsvButton({ href, testid = "export-csv", label = "تصدير CSV" }) {
  return (
    <a
      data-testid={testid}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-sm font-bold bg-slate-100 hover:bg-slate-200 text-slate-900 px-4 py-2.5 rounded-lg transition-colors cursor-pointer"
    >
      <Download className="w-4 h-4" />
      <span>{label}</span>
    </a>
  );
}
